import useSWRMutation from "swr/mutation";
import { API_REST_METHODS } from "../../../common/constants";
import { fetcher } from "../../../common/hooks";

export const useDeleteBulkSpaceAssignments = ({
    companyId,
    locationId,
    onSuccess,
    onError,
}: {
    companyId: string;
    locationId: string;
    onSuccess?: () => void;
    onError?: (err: any, key: string) => void;
}) => {
    const {
        trigger: triggerDeleteBulkSpaceAssignments,
        isMutating: isLoadingDeleteBulkSpaceAssignments,
    } = useSWRMutation(
        `/api/device-management/v1/companies/${companyId}/locations/${locationId}/deviceAssignments/unassign-bulk`,
        (
            url: string,
            {
                arg,
            }: {
                arg: {
                    deviceId: string;
                    spaceId: string;
                    subSpaceId?: string;
                }[];
            }
        ) =>
            fetcher(url, {
                options: {
                    method: API_REST_METHODS.PUT,
                    body: JSON.stringify(arg),
                },
            }),
        {
            onSuccess,
            onError,
        }
    );

    return {
        triggerDeleteBulkSpaceAssignments,
        isLoadingDeleteBulkSpaceAssignments,
    };
};
